import { AtlassianLogo } from '@atlaskit/logo';
import { colors, gridSize } from '@atlaskit/theme';
import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { redirect } from '../../facade/window';
import { AnalyticsConsumerProps, withAnalytics } from '../../hoc/withAnalytics';

export const Container = styled.footer`
  border-top: 1px solid ${colors.N40};
  padding: ${gridSize()}px 0;
  color: ${colors.N200};
  text-align: center;

  p {
    margin: 4px 0 ${gridSize()}px;
  }
`;

class InterimFooter extends React.Component<AnalyticsConsumerProps> {
  handleLearnMoreClick = async (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    const url = event.currentTarget.href; // save before await because React will reuse this Event instance for bubbling
    await this.props.analytics.ui(
      'link',
      'clicked',
      {},
      { actionSubjectId: 'learnMoreLink', source: 'joinableSitesScreen' },
    );
    redirect(url);
  };

  render() {
    return (
      <Container>
        <AtlassianLogo iconColor={colors.N500} textColor={colors.N500} />
        <p>
          <FormattedMessage {...messages.oneAccount} />{' '}
          <a
            href="https://confluence.atlassian.com/cloud/your-atlassian-account-976161169.html"
            onClick={this.handleLearnMoreClick}
          >
            <FormattedMessage {...messages.learnMore} />
          </a>
        </p>
      </Container>
    );
  }
}

export default withAnalytics(InterimFooter);

export const messages = defineMessages({
  learnMore: {
    defaultMessage: 'Learn more.',
    description: 'Text of the link displayed in the footer of the interim home page',
    id: 'uchi.interimHome.learnMore',
  },
  oneAccount: {
    defaultMessage: 'One account for all things Atlassian.',
    description: 'Text displayed in the footer of the interim home page',
    id: 'uchi.interimHome.oneAccount',
  },
});
